import { Accessibility } from "./accessibility";
import { Accessible } from "./accessible";
import { AccountBalance } from "./account_balance";
import { AccountBalanceWallet } from "./account_balance_wallet";
import { AccountBox } from "./account_box";
import { AddBusiness } from "./add_business";
import { Agriculture } from "./agriculture";
import { AlternateEmail } from "./alternate_email";
import { AssistantPhoto } from "./assistant_photo";
import { AutoStories } from "./auto_stories";

const iconsList = [
  { label: "Accessibility", code: <Accessibility /> },
  { label: "Accessible", code: <Accessible /> },
  { label: "AccountBalance", code: <AccountBalance /> },
  { label: "AccountBalanceWallet", code: <AccountBalanceWallet /> },
  { label: "AccountBox", code: <AccountBox /> },
  { label: "AddBusiness", code: <AddBusiness /> },
  { label: "Agriculture", code: <Agriculture /> },
  { label: "AlternateEmail", code: <AlternateEmail /> },
  { label: "AssistantPhoto", code: <AssistantPhoto /> },
  { label: "AutoStories", code: <AutoStories /> },
];

export {
  iconsList,
  Accessibility,
  Accessible,
  AccountBalance,
  AccountBalanceWallet,
  AccountBox,
  AddBusiness,
  Agriculture,
  AlternateEmail,
  AssistantPhoto,
  AutoStories,
};
